import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, InfoIcon } from 'lucide-react';
import { easeOutStrong } from '../../utils/motion';
export function ResearchIntro() {
  return <section className="bg-white border-b border-line pt-32 pb-20 lg:pt-44 lg:pb-24" data-id="element-1428" data-mp="39whlprfo87bp">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: easeOutStrong
    }} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-1429" data-mp="3evc4itdn1vvt">
        <div className="lg:col-span-5" data-id="element-1430" data-mp="34z93xryfq5az">
          <p className="text-sm font-medium text-teal mb-5" data-id="element-1431" data-mp="2r69otr2ked3y">Research</p>
          <h1 className="font-heading font-extrabold text-5xl lg:text-6xl text-ink-dark leading-[1.05] tracking-tight" data-id="element-1432" data-mp="2r3wz2rqkeygc">
            Two connected questions
          </h1>
        </div>
        <div className="lg:col-span-7 lg:pt-10" data-id="element-1433" data-mp="2h9n5x7tstw4k">
          <p className="text-2xl text-ink-dark leading-relaxed mb-6" data-id="element-1434" data-mp="2m6wrudhzbpnn">
            SyNeural’s research begins with two connected questions: How do
            people develop sound judgment? And how can knowledge systems help
            researchers and institutions think more clearly?
          </p>
          <p className="text-lg text-ink-muted leading-relaxed mb-8" data-id="element-1435" data-mp="c9itpfzzay8r">
            Our work brings together cognitive science, human development,
            semantic knowledge, institutional design, and responsible AI. The
            Semantic Knowledge Platform (SKP) connects ideas across research and
            policy. The Human Capability Framework, including CJI and NCJI,
            explores how judgment can be understood, developed, and reassessed
            over time. Noetivra, our planned interactive workspace, is where
            we are exploring how people see and use that knowledge.
          </p>
          <div className="flex gap-4 bg-surface-muted rounded-lg p-5 mb-8" data-id="element-1436" data-mp="2wy5h9jzg6fl0">
            <InfoIcon size={20} className="text-navy-light shrink-0 mt-0.5" aria-hidden="true" data-id="element-1437" data-mp="2syobepg3zgfb" />
            <p className="text-ink-dark leading-relaxed" data-id="element-1438" data-mp="vxs4juvw7f5i">
              These are active areas of research and product development.
              Concepts described here may require further testing, validation,
              and institutional review before they are suitable for
              consequential use.
            </p>
          </div>
          <a href="/roadmap" className="inline-flex items-center gap-2 text-navy font-semibold hover:text-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-1439" data-mp="1ald8ts4i7kf0">
            See where our research is going
            <ArrowRight size={16} data-id="element-1440" data-mp="mw13j3carwhz" />
          </a>
        </div>
      </motion.div>
    </section>;
}